import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import { Chip } from '@mui/material';

const StyledCheckboxChip = styled(Chip)(({ theme, selected }) => ({
  marginRight: theme.spacing(1),
  backgroundColor: selected
    ? theme.palette.customPurple3.main
    : theme.palette.grey[300],
  color: selected
    ? theme.palette.common.white
    : theme.palette.text.primary,
  transition: 'none',
  '&:hover': {
    backgroundColor: theme.palette.customPurple2.main,
    color: theme.palette.common.white,
  },
  '&:hover:active': {
    backgroundColor: theme.palette.customPurple2.main,
    color: theme.palette.common.white,
  },
}));

const CheckboxChip = ({ label, value, state, setState }) => {
  const selected = Array.isArray(state) ? state.includes(value) : state === value;

  return (
    <StyledCheckboxChip
      label={label}
      onClick={() => setState(value)}
      selected={selected}
      data-testid={label}
      data-testselected={selected ? 'true' : 'false'}
    />
  );
};

CheckboxChip.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  state: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]).isRequired,
  setState: PropTypes.func.isRequired,
};

export default CheckboxChip;
